import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    LogOut,
    Bell,
    Sparkles,
    User,
    Search
} from 'lucide-react';
import ChatSection from '../dashboard/ChatSection';
import ResizableModal from '../dashboard/ResizableModal';

export default function Navbar({ children, userName }) {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const navLinks = [
        { name: 'Dashboard', href: '/' },
        { name: 'Claims', href: '/claim' },
        { name: 'Reports', href: '/reports' },
        { name: 'Smart Table', href: '/smarttable' }
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <div className="flex flex-col min-h-screen bg-background font-sans">
            {/* Tier 1: Top Global Header */}
            <header className="bg-[#1A1A1A] h-16 flex items-center justify-between px-8 z-20 flex-shrink-0">
                <div className="flex items-center">
                    {/* <img
                        src="https://www.mazdausa.com/siteassets/images/home/4218-update/mazda-usa-logo"
                        alt="Mazda Logo"
                        className="object-contain w-24 h-8 mr-6"
                    /> */}
                    <h2 className="text-white text-xs font-light uppercase tracking-widest hidden sm:block">
                        iCPS : Intelligent Claims Processing Solution
                    </h2>
                </div>

                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="hidden md:flex relative">
                        <input 
                            type="text" 
                            placeholder="SEARCH..." 
                            className="bg-[#0B0B0B] text-white placeholder-gray-500 rounded-none pl-10 pr-4 py-2 text-[10px] uppercase tracking-widest focus:outline-none border border-transparent focus:border-white transition-colors w-64"
                        />
                        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-500" />
                    </div>

                    <button className="text-white hover:text-gray-300 transition-colors">
                        <Bell className="h-5 w-5" />
                    </button>
                    
                    <div className="flex items-center space-x-3 text-white cursor-pointer hover:text-gray-300 transition-colors">
                        <div className="w-8 h-8 rounded-none border border-gray-700 flex items-center justify-center bg-[#0B0B0B]">
                            <User className="h-4 w-4" />
                        </div>
                        <div className="hidden md:block text-left">
                            <p className="text-[10px] font-semibold uppercase tracking-widest">{userName}</p>
                        </div>
                    </div>

                    <button className="text-white hover:text-gray-300 transition-colors ml-4" title="Logout">
                        <LogOut className="h-5 w-5" />
                    </button>
                </div>
            </header>

            {/* Tier 2: Secondary Horizontal Ribbon */}
            <nav className="bg-[#0B0B0B] w-full flex justify-center items-center py-4 px-8 z-10 flex-shrink-0">
                <div className="flex space-x-8 md:space-x-12">
                    {navLinks.map((link) => {
                        const active = isActive(link.href);
                        return (
                            <Link
                                key={link.name}
                                to={link.href}
                                className={`text-xs uppercase tracking-[0.15em] font-semibold transition-colors duration-200 pb-2 border-b-2 ${
                                    active 
                                        ? 'text-white border-white' 
                                        : 'text-gray-400 hover:text-gray-200 border-transparent'
                                }`}
                            >
                                {link.name}
                            </Link>
                        );
                    })}
                </div>
            </nav>

            {/* Main Content Wrapper */}
            <main className="flex-1 overflow-auto p-8 relative">
                {children}

                {/* Floating AI Button */}
                <motion.button
                    onClick={handleOpenModal}
                    animate={{ rotate: isModalOpen ? 180 : 0 }}
                    transition={{ type: 'spring', stiffness: 260, damping: 22 }}
                    className="fixed bottom-8 right-8 bg-[#1A1A1A] hover:bg-black text-white p-4 rounded-full border border-white shadow-lg focus:outline-none z-50 flex items-center justify-center"
                    title="Ask AI"
                >
                    <Sparkles className="h-6 w-6" />
                </motion.button>
            </main>

            {/* AI Modal */}
            <ResizableModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            >
               <ChatSection onClose={handleCloseModal}/>
            </ResizableModal>
        </div>
    );
}